import { MEMBER_API, ADMIN_API } from '../constants/endpoints';

/**
 * Extract OSS/object storage key from a full URL, proxy URL, or raw key.
 * Never use Aliyun bucket host in UI — resolve via {@link resolveMediaUrl}.
 */
export function toObjectKey(value) {
  if (value == null || value === '') {
    return '';
  }
  let raw = String(value).trim();
  if (!raw || raw.startsWith('data:')) {
    return raw;
  }

  if (/^https?:\/\//i.test(raw)) {
    try {
      const url = new URL(raw);
      raw = url.pathname || '';
    } catch {
      const idx = raw.indexOf('://');
      const slash = raw.indexOf('/', idx + 3);
      raw = slash >= 0 ? raw.slice(slash) : '';
    }
  }

  raw = raw.replace(/^\/+/, '');

  const markers = [
    'common/media/',
    'formosa-member/member/common/media/',
    'formosa-admin/admin/common/media/',
  ];
  for (const marker of markers) {
    const at = raw.indexOf(marker);
    if (at >= 0) {
      raw = raw.slice(at + marker.length);
      break;
    }
  }

  return raw.replace(/^\/+/, '');
}

/**
 * Build a browser-safe media URL via Gateway media proxy (hides OSS bucket domain).
 * Legacy full OSS URLs are rewritten to the proxy using the extracted objectKey.
 *
 * @param {string} value objectKey, proxy URL, or legacy OSS URL
 * @param {{ base?: string }} [options]
 */
export function resolveMediaUrl(value, options = {}) {
  if (value == null || value === '') {
    return '';
  }
  const text = String(value).trim();
  if (!text) {
    return '';
  }
  if (text.startsWith('data:')) {
    return text;
  }

  const base = (options.base || `${MEMBER_API}/common/media`).replace(/\/$/, '');
  const key = toObjectKey(text);
  if (!key) {
    return '';
  }
  // Already a same-origin proxy path without host
  if (text.startsWith(base) || text.includes('/common/media/')) {
    if (/^https?:\/\//i.test(text) && !/\.aliyuncs\.com/i.test(text)) {
      return text;
    }
  }
  return `${base}/${key}`;
}

export function resolveAdminMediaUrl(value) {
  return resolveMediaUrl(value, { base: `${ADMIN_API}/common/media` });
}

export function resolveMemberMediaUrl(value) {
  return resolveMediaUrl(value, { base: `${MEMBER_API}/common/media` });
}
